import { Suspense } from 'react';
import { Outlet, matchPath, useLocation } from 'react-router-dom';

import { LoadingIndicator } from '@sorare/core/src/atoms/loader/LoadingIndicator';
import {
  FOOTBALL_HOME,
  FOOTBALL_PLAY,
} from '@sorare/core/src/constants/__generated__/routes';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { useIsMobile } from '@sorare/core/src/hooks/device/useIsMobile';

import { AppLayout } from '@sorare/gameplay/src/components/navigation/AppLayout';

import { LoyaltyBoxButton } from 'components/LoyaltyBoxButton';
import { FootballMarketSubscriptions } from 'routing/FootballMarketSubscriptions';

import { usePackOpeningInterruptedSnackbar } from './usePackOpeningInterruptedSnackbar';

const FootballLayout = () => {
  const { currentUser, footballUserProfile } = useCurrentUserContext();
  const location = useLocation();
  const isMobile = useIsMobile();
  const { forcedIntoOnboarding } = currentUser || {};
  usePackOpeningInterruptedSnackbar();

  if (
    forcedIntoOnboarding &&
    !footballUserProfile?.commonGameOnboarded &&
    (matchPath(FOOTBALL_PLAY, location.pathname) ||
      matchPath(FOOTBALL_HOME, location.pathname))
  ) {
    return <Outlet />;
  }
  return (
    <AppLayout extraHeaderButton={!isMobile && <LoyaltyBoxButton />}>
      <FootballMarketSubscriptions />
      <Suspense fallback={<LoadingIndicator fullHeight />}>
        <Outlet />
      </Suspense>
    </AppLayout>
  );
};
export default FootballLayout;
